var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconoBaja = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4731_215)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4731_215",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4731_215)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.78338 14.8L4.53338 12.7333L2.18338 12.2L2.40005 9.79995L0.800049 7.99995L2.40005 6.19995L2.18338 3.79995L4.53338 3.26662L5.78338 1.19995L8.00005 2.14995L10.2167 1.19995L11.4667 3.26662L13.8167 3.79995L13.6 6.19995L15.2 7.99995L13.6 9.79995L13.8167 12.2L11.4667 12.7333L10.2167 14.8L8.00005 13.85L5.78338 14.8ZM6.26672 13.2833L8.00005 12.55L9.73338 13.2833L10.7 11.6666L12.5334 11.25L12.3667 9.39995L13.6 7.99995L12.3667 6.59995L12.5334 4.74995L10.7 4.33328L9.73338 2.71662L8.00005 3.44995L6.26672 2.71662L5.30005 4.33328L3.46672 4.73328L3.63338 6.59995L2.40005 7.99995L3.65005 9.39995L3.46672 11.2666L5.30005 11.6833L6.26672 13.2833Z",
    fill: "#A30A10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.20006 9.03309L6.83339 10.3998L6.00006 9.56642L7.36673 8.19976L6.00006 6.83309L6.83339 5.99976L8.20006 7.36642L9.56673 5.99976L10.4001 6.83309L9.03339 8.19976L10.4001 9.56642L9.56673 10.3998L8.20006 9.03309Z",
    fill: "#A30A10"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4731_215"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconoBaja, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/icono_baja.155a9f04.svg";
export { ForwardRef as ReactComponent };